import $ from "jquery";

export default {
  init() {
    // this.listenScroll();
    this.isSafari();
    this.initMobileMenu();
    this.scrollToAnchor();
  },
  scrollToAnchor() {
    var self = this;

    $("#navmain a").on("click", function (e) {
      const link = $(this).attr("href");

      if (link.indexOf("#") > -1) {
        self.hideMenu();
        e.preventDefault();
        const myArray = link.split("#");
        let anchor = myArray[1];
        var marginTop = 160; // Increased to better account for navbar height
        // Responsive adjustment for different screen sizes
        if ($(document).width() <= 768) {
          marginTop = 140; // Slightly smaller for mobile
        }

        $("html, body").animate(
          {
            scrollTop: $("#" + anchor).offset().top - marginTop,
          },
          500,
        );
      }
    });
  },
  initMobileMenu() {
    var self = this;

    document
      .querySelector("#navmain")
      .addEventListener("click", function (event) {
        event.stopPropagation();
      });

    document.addEventListener("click", function () {
      if (
        document.querySelector("#navmain").classList.contains("open-mobile")
      ) {
        self.hideMenu();
      }
    });

    if (document.querySelector("#hamb-cross") != null) {
      document
        .querySelector("#hamb-cross")
        .addEventListener("click", function (event) {
          if (this.classList.contains("open")) {
            self.hideMenu();
            event.stopPropagation();
          } else {
            self.showMenu();
            event.stopPropagation();
          }
        });
    }
  },
  hideMenu() {
    var self = this;

    document.querySelector("#navmain").classList.remove("open-mobile");
    document.querySelector("body").classList.remove("open-mobile-menu");
    document.querySelector("#hamb-cross").classList.remove("open");
    document.querySelector("#loader").classList.remove("show");
    // var parentElements = document.querySelectorAll('.menu-item-has-children')
    // self.hideAllSibling(parentElements, '');
  },
  showMenu() {
    document.querySelector("#navmain").classList.add("open-mobile");
    document.querySelector("body").classList.add("open-mobile-menu");
    document.querySelector("#hamb-cross").classList.add("open");
    document.querySelector("#loader").classList.add("show");
  },
  hideAllSibling(parents, current) {
    for (var i = 0; i < parents.length; i++) {
      if (parents[i] != current) {
        parents[i].classList.remove("activated");
      }
    }
  },
  isSafari() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      document.querySelector("body").classList.add("safari");
    }
  },
};
